import axios from 'axios'
import { ShipmentEntityTypeEnumResponse } from '@/modules/shipments-module/services/auxiliary/shipments-auxiliary.dto'

class ShipmentsAuxiliaryService {
    // Find all shipment entity types
    async getShipmentEntityTypes(): Promise<ShipmentEntityTypeEnumResponse[]> {
        const response = await axios.get<ShipmentEntityTypeEnumResponse[]>(`/shipments/shipmentEntityTypes/`)
        return response.data
    }

    // Find all shipment request statuses
    async getShipmentRequestStatuses(): Promise<ShipmentEntityTypeEnumResponse[]> {
        const response = await axios.get<ShipmentEntityTypeEnumResponse[]>(`/shipments/shipmentRequestStatuses/`)
        return response.data
    }
}

export const shipmentsAuxiliaryService = new ShipmentsAuxiliaryService()
